export default __webpack_public_path__ + "static/media/mantle_bg275.46da4f4c.jpg";